import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { SITE } from "@/data/networks";
import { networkFromPath, track } from "@/lib/track";

const SOCIAL_HOSTS = ["facebook.com", "youtube.com", "instagram.com", "linkedin.com"];

const classify = (href) => {
  if (href.startsWith(`${SITE}/welcome`)) return "signup_click";
  if (SOCIAL_HOSTS.some((h) => href.includes(h))) return "follow_click";
  return null;
};

export const Analytics = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    if (["/stats", "/kit", "/runsheet"].includes(pathname) || pathname.startsWith("/p/")) return;
    track("page_view", networkFromPath(pathname));
  }, [pathname]);

  useEffect(() => {
    const onClick = (e) => {
      const a = e.target.closest("a[href]");
      if (!a) return;
      const event = classify(a.href);
      if (event) track(event, networkFromPath(window.location.pathname));
    };
    document.addEventListener("click", onClick);
    return () => document.removeEventListener("click", onClick);
  }, []);

  return null;
};
